module.exports = __webpack_public_path__ + "img/signal-widget-wallpaper.96fa67f2.png";